import { render, staticRenderFns } from "./RedirectTab.vue?vue&type=template&id=ae4e8434&scoped=true"
import script from "./RedirectTab.vue?vue&type=script&lang=js"
export * from "./RedirectTab.vue?vue&type=script&lang=js"
import style0 from "./RedirectTab.vue?vue&type=style&index=0&id=ae4e8434&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4e8434",
  null
  
)

export default component.exports